import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService

  ) { }

  canActivate(): boolean {
    if (this.authService.hasValidAccessToken()) {
      return true;
    }

    this.router.navigate(['/signin']);
    return false;
  }
}
